const COLOR_PRESET = Object.freeze({
    LIGHT: { 
        CB: {
            TEXT: '#111E43',
            TEXT_BUTTON: '#005CAF',
            ERROR: '#8B008B',
            SUCCESS: '#007B8A',
        },
        DEFAULT: {
            TEXT: '#FFFFFF',
            TEXT_BUTTON: '#111E43',
            ERROR: '#EB573D',
            SUCCESS: '#009C66',
        } 
    },
    DARK: { 
        CB: {
            TEXT: '#FFFFFF',
            TEXT_BUTTON: '#1E90FF',
            ERROR: '#9D00E0',
            SUCCESS: '#00CED1',
        },
        DEFAULT: {
            TEXT: '#FFFFFF',
            TEXT_BUTTON: '#FFFFFF',
            ERROR: '#b71c1c',
            SUCCESS: '#009C66',
        }  
    },
});

export default COLOR_PRESET;
